import { Typography } from "@/components/ui";
import { UserProfilePhoto } from "@/components/ui/UserProfilePhoto/UserProfilePhoto";
import type { User } from "@/lib/types";
import { convertToLocalFromDatabaseDateTime } from "@/lib/utils/dateUtils";
import {
  formatDate,
  formatDateTime,
  formatUsersName,
} from "@/lib/utils/format";

type CreatedByUser = Pick<
  User,
  "id" | "firstName" | "lastName" | "profilePicturePresignedUrlKey"
>;

export const CreatedByUserText = ({
  user,
  dateTime,
  showTime = false,
  showTimeZone = false,
}: {
  user?: CreatedByUser;
  dateTime: string;
  showTime?: boolean;
  showTimeZone?: boolean;
}) => {
  const userName = formatUsersName(user) ?? "Unknown user";
  const formattedDateTime = showTime
    ? formatDateTime(
        convertToLocalFromDatabaseDateTime(dateTime) ?? "",
        showTimeZone,
      )
    : formatDate(convertToLocalFromDatabaseDateTime(dateTime) ?? "");

  return (
    <div className="mt-2 flex w-full items-center gap-x-2">
      <UserProfilePhoto
        className="h-4 w-4"
        initialsClassName="text-[8px]"
        user={user}
      />
      <Typography variant="subHeading" size="xs">
        {`${userName} • ${formattedDateTime}`}
      </Typography>
    </div>
  );
};
